import { ISelectOptions } from "src/@types/select";

export const EXPORT_FORMATS = {
  excel: { extension: "xlsx", label: "Excel" },
  pdf: { extension: "pdf", label: "PDF" },
} as const;

export type ExportKind = keyof typeof EXPORT_FORMATS;

export const EXPORT_DATE_FORMAT = "yyyy-MM-dd";

export const CASH_MOVEMENT_LABELS = {
  pageTitle: "Movimento de Caixa e Crediário",
  pageDescription: "Gere o movimento de caixa de um dia fechado por loja",
  storeLabel: "Loja",
  storePlaceholder: "Selecione a loja",
  dateLabel: "Data",
  datePlaceholder: "Selecione o dia fechado",
  operatorLabel: "Operador (opcional)",
  operatorPlaceholder: "Todos",
  excelButton: "Gerar Excel",
  pdfButton: "Gerar PDF",
  generating: "Enviando…",
  selectFiltersHint: "Selecione a loja e a data para gerar o relatório",
} as const;

export const GLOBALLY_HANDLED_STATUS: ReadonlySet<number> = new Set([
  401, 403, 423,
]);

export const CASH_MOVEMENT_MESSAGES = {
  MISSING_FILTERS: {
    description: "Selecione a loja e a data antes de gerar o relatório",
    variant: "destructive" as const,
  },
  EMPTY: {
    description: "Nenhum lançamento para a loja e data selecionadas",
  },
  EXPORT_QUEUED: {
    description:
      "Estamos gerando sua exportação. Ela chegará em {email} e nas suas notificações.",
  },
  ERROR: {
    description: "Não foi possível gerar o relatório",
    variant: "destructive" as const,
  },
};

export const EMAIL_PLACEHOLDER = "{email}";

export type StoreOption = ISelectOptions[number];

export type StoreOptions = ISelectOptions;
